export * from "@/components/base-ui/tabs";
